export default __webpack_public_path__ + "static/media/food-2.e7e68da8.png";